import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import pt from "./translations/pt.json";
import en from "./translations/en.json";
import es from "./translations/es.json";

const SUPPORTED = ["pt", "en", "es"] as const;
const LANG_STORAGE_KEY = "sdd-lang";

const HTML_LANG: Record<string, string> = {
  pt: "pt-BR",
  en: "en-US",
  es: "es-ES",
};

export function htmlLang(language: string) {
  return HTML_LANG[language] ?? language;
}

function isSupported(value: string | null | undefined) {
  return !!value && (SUPPORTED as readonly string[]).includes(value);
}

function detectLanguage() {
  try {
    const saved = localStorage.getItem(LANG_STORAGE_KEY);
    if (isSupported(saved)) return saved as string;
  } catch {}

  for (const tag of navigator.languages ?? [navigator.language]) {
    const base = tag?.split("-")[0]?.toLowerCase();
    if (isSupported(base)) return base as string;
  }

  return "pt";
}

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: pt },
    en: { translation: en },
    es: { translation: es },
  },
  lng: detectLanguage(),
  supportedLngs: SUPPORTED,
  fallbackLng: "pt",
  interpolation: { escapeValue: false },
});

const syncLanguage = (language: string) => {
  document.documentElement.lang = htmlLang(language);
  try {
    localStorage.setItem(LANG_STORAGE_KEY, language);
  } catch {}
};

syncLanguage(i18n.language);
i18n.on("languageChanged", syncLanguage);

export default i18n;
